import Rete from "rete";
import { StatsOperationSocket,StatsOperationsControl } from "../rete-controls/StatsOperationControl.js"
import ReteComponentStore from "../ReteComponentStore.js"

export default class StatsOperationsComponent extends Rete.Component {
    constructor(){
        super("Statistics Operations"); // name
        this._categories = ["Statistics Nodes", "tryMe"];
    }

    builder(node) {
        let out1 = new Rete.Output('out1','OP',StatsOperationSocket);
        let opControl = new StatsOperationsControl(this.editor,"op");

        return node
        .addOutput(out1)
        .addControl(opControl);
    }

    worker(node, inputs, outputs) {
        outputs['out1'] = node.data.op;

        //console.log(this.name + " node.data= " + JSON.stringify(node.data));
        //console.log(this.name + " outputs= " + JSON.stringify(outputs));
    }
}

//ReteComponentStore.add(new OperationsComponent())

